import toast, {ToastType} from '@/components/Toast';
import {copyToClipboard} from '@/utils/commonUtils';
import {IChatMessage} from '../request.type';
import {TextUIPart} from './Chat/type';
import {RegMap} from './Chat/Messages/Markdown/constant';
import {matchAllPolyfill} from './Chat/Messages/Markdown/utils';

/**
 * 查找最新的包含 artifacts 的消息
 * @param messages 对话消息列表
 */
export const findLatestMessageWithArtifact = (
    messages: IChatMessage[]
): IChatMessage | undefined => {
    const reverseAssistantMessages = messages.filter(item => item.role === 'assistant').reverse();
    const latestMessageWithArtifact: IChatMessage | undefined = reverseAssistantMessages.find(({parts}) => {
        const allContent = parts.reduce((total, part) => {
            if (!(part as unknown as any)?.text) {
                return total;
            }
            return total + ((part as TextUIPart)?.text || '');
        }, '');

        const hasArtifact = matchAllPolyfill(allContent, RegMap.Artifact);
        return hasArtifact;
    });
    return latestMessageWithArtifact;
};

/**
 * 复制文本
 */
export const copyText = (text: string, toastText = '已复制') => {
    copyToClipboard({
        'text/plain': text,
    }).then(() => {
        toast({type: ToastType.Success, content: toastText});
    });
};
